import getStore from '../store/store';

/**
 * Util to get published status of the booking page from store.
 */
export default function getAnonymousSharingStatus(): boolean {
    let store = getStore();
    return store.isAnonymousSharingEnabled;
}
